export function IconTech({ icon, iconSize }) {
  return <img src={icon} alt="icon-tech" width={iconSize} />;
}
